import request from 'superagent';
import url from '../../utils/url';

export const actionTypes = {
  SIDEBAR_DATA_REQUEST: 'SIDEBAR_DATA_REQUEST',
  SIDEBAR_DATA_SUCCESS: 'SIDEBAR_DATA_SUCCESS',
  SIDEBAR_DATA_ERROR: 'SIDEBAR_DATA_ERROR',
};

export const getSidebarData = (params = {}) => (dispatch) => {
  dispatch({
    type: actionTypes.SIDEBAR_DATA_REQUEST,
    data: { status: 'loading' },
  });

  const onSuccess = (resp) => {
    const { data = {} } = resp.body;
    dispatch({
      type: actionTypes.SIDEBAR_DATA_SUCCESS,
      data: { ...data, status: 'done' },
    });
  };

  const onFailure = (error) => {
    dispatch({
      type: actionTypes.SIDEBAR_DATA_ERROR,
      error,
    });
  };

  const { type = 'filings' } = params;

  return request
    .get(url(`/ui/sidebar?url=${type}`))
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .then(onSuccess, onFailure);
};



// WEBPACK FOOTER //
// ./src/redux/actions/sidebarActions.js